// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file activity/v1/equipment.proto (package activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message activity.v1.Equipment
 */
export class Equipment extends Message<Equipment> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<Equipment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "activity.v1.Equipment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Equipment {
    return new Equipment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Equipment {
    return new Equipment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Equipment {
    return new Equipment().fromJsonString(jsonString, options);
  }

  static equals(a: Equipment | PlainMessage<Equipment> | undefined, b: Equipment | PlainMessage<Equipment> | undefined): boolean {
    return proto3.util.equals(Equipment, a, b);
  }
}

